import { isArrayLike } from '../../common/commonUtils/isArrayLike.js';

export function getIndex(options: { targetIndex: number; collection: any[] }): number {
	const { targetIndex, collection } = options;
	const response = -1;

	if (!isArrayLike(collection) || collection.length <= 0) {
		return response;
	}

	if (targetIndex < 0) {
		const reverseIndex = collection.length + targetIndex;
		return reverseIndex < 0 ? -1 : reverseIndex;
	}

	if (targetIndex >= 0 && targetIndex < collection.length) {
		return targetIndex;
	}

	return response;
}
